<div class="px-3 pt-4">
    <h2 class="modal-title" [translateParams]="{disableType: disableType}" translate="Settings.AccountSecuritySection.Dialog.DisableSecurity"></h2>
</div>
<form [formGroup]="form" (ngSubmit)="disableSecurityItem()">
    <div class="modal-body pb-5">
        <div class="alert alert-primary border-primary text-body p-2 workflowPlaceholder" role="alert">
            <span class="lh-base" translate="Settings.AccountSecuritySection.Dialog.DisableSecurityInformation"></span>
        </div>

        <div class="col-12">
            <label for="password" class="form-label" translate="Settings.AccountSecuritySection.Dialog.Password"></label>
            <input type="password" id="password" formControlName="password" class="form-control" placeholder="{{ 'Settings.AccountSecuritySection.Dialog.Password' | translate }}">
        </div>
    </div>

    <div class="d-table px-3 py-4 w-100">
        <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()" translate="Button.Back"></button></span>
        <span class="float-end"><button type="submit" class="btn btn-sm btn-danger" [disabled]="!form.valid" translate="Button.Disable"></button></span>
    </div>
</form>